import axios from "axios";

export enum ActionType {
    REQUEST_PRODUCT_DATA = "REQUEST_PRODUCT_DATA",
    RECEIVE_PRODUCT_DATA = "RECEIVE_PRODUCT_DATA",
    RECEIVE_PRODUCT_DATA_ERROR = "RECEIVE_PRODUCT_DATA_ERROR",
    REQUEST_SPEC_DATA = "REQUEST_SPEC_DATA",
    RECEIVE_SPEC_DATA = "RECEIVE_SPEC_DATA",
    RECEIVE_SPEC_DATA_ERROR = "RECEIVE_SPEC_DATA_ERROR",
    EXPAND_ALL_SPECS = "EXPAND_ALL_SPECS",
    COLLAPSE_ALL_SPECS = "COLLAPSE_ALL_SPECS",
    EXPAND_SPEC = "EXPAND_SPEC",
    COLLAPSE_SPEC = "COLLAPSE_SPEC",
    EXPAND_DOWNLOAD_CAT = "EXPAND_DOWNLOAD_CAT",
    COLLAPSE_DOWNLOAD_CAT = "COLLAPSE_DOWNLOAD_CAT"
}

interface receiveProductData {
    type: ActionType.RECEIVE_PRODUCT_DATA,
    payload: any
}

interface requestProductData {
    type: ActionType.REQUEST_PRODUCT_DATA
}

interface receiveProductDataError {
    type: ActionType.RECEIVE_PRODUCT_DATA_ERROR,
    payload: string
}

interface receiveSpecData {
    type: ActionType.RECEIVE_SPEC_DATA,
    payload: any
}

interface receiveSpecDataError {
    type: ActionType.RECEIVE_SPEC_DATA_ERROR,
    payload: string
}

interface requestSpecData {
    type: ActionType.REQUEST_SPEC_DATA
}

interface expandAllSpecs {
    type: ActionType.EXPAND_ALL_SPECS
}

interface collapseAllSpecs {
    type: ActionType.COLLAPSE_ALL_SPECS
}

interface expandSpec {
    type: ActionType.EXPAND_SPEC,
    payload: string
}

interface collapseSpec {
    type: ActionType.COLLAPSE_SPEC,
    payload: string
}

//Do the collapse/expand for downloads too
interface expandDownloadCat {
    type: ActionType.EXPAND_DOWNLOAD_CAT,
    payload: string
}

interface collapseDownloadCat {
    type: ActionType.COLLAPSE_DOWNLOAD_CAT,
    payload: string
}

export type Action = receiveProductData | 
requestProductData | 
receiveProductDataError | 
receiveSpecData | 
requestSpecData | 
receiveSpecDataError | 
expandAllSpecs | 
collapseAllSpecs | 
expandSpec | 
collapseSpec | 
expandDownloadCat |
collapseDownloadCat;